import React, {useContext} from 'react';
import {observer} from 'mobx-react';
import DownloadContext from '../../stores/DownloadContext';
import Submenu from '../common/Submenu';
import Links from '../common/Links';
import ListFilters from '../common/ListFilters';
import CustomSelect from '../common/CustomSelect';
import TranslationContext from '../../utils/I18n';
import Block from '../common/Block';

const DownloadFilters = () => {
	const {
		onlyFamily,
		availableFilters,
		filters,
		filteredRows,
		prettySelectedFilters,
		config
	} = useContext(DownloadContext);
	if (onlyFamily !== false) return null; // don’t show the filters if we are in a “onlyFamily” context
	const store = useContext(DownloadContext);
	const t = useContext(TranslationContext);
	const resultsCount = filteredRows.length - 1; // -1 because of the “all“ row
	if (!config.showFilters) return null;
	const areaLinks = filters.map(s => ({
		label: s.label,
		active: s.active,
		href: `#${s.key}`,
		onClick: ev => {
			ev.preventDefault();
			store.setSelectedArea(s.key);
		}
	}));
	return (
		<>
			<Submenu>
				<Links links={areaLinks}/>
			</Submenu>

			{availableFilters && (
				<Block modifiers={{
					adaptiveGrid: true,
					colorSchemeDefault: true,
					hAlignCenter: true,
					hAlignHeaderInherit: true,
					hSizeFullNoContentPadding: true,
					hPositionCenter: true,
					hPositionMultiInherit: true,
					paddingTopDefault: true,
					paddingTopMultiDefault: true,
					paddingLeftDefault: true,
					paddingLeftMultiDefault: true,
					paddingRightDefault: true,
					paddingRightMultiDefault: true,
					downloadHeader: true
				}}>
					<ListFilters
						filters={
							availableFilters.map((group, idx) => (
								<CustomSelect
									key={group.key}
									label={t(`downloads.${group.key}`)}
									onChange={option => {
										store.toggleFilter(option.value);
									}}
									options={group.filters.map(f => ({
										label: f.label,
										value: f.key,
										disabled: f.disabled,
										selected: f.active
									}))}
									implicitCheck={group.filters.filter(f => f.active).length === 0}
									onClickReset={() => {
										store.resetFilters(group.key);
									}}
								/>
							))
						}
						activeFilters={prettySelectedFilters}
						onClickActiveFilter={item => {
							store.toggleFilter(item.key);
						}}
						onClickReset={() => store.resetFilters()}
						resetCount={resultsCount}
					/>
				</Block>
			)}

		</>

	);
};


export default observer(DownloadFilters);
